import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from '../Pages/Home';
import ProjectDetail from "../Pages/ProjectDetail";

const Navigation = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/">
                    <Home></Home>
                </Route>
                <Route exact path="/home">
                    <Home></Home>
                </Route>
                <Route exact path="/project/detail/:id">
                    <ProjectDetail></ProjectDetail>
                </Route>

            </Switch>
        </BrowserRouter>
    );
};

export default Navigation;